import { render, staticRenderFns } from "./EmojiContent.vue?vue&type=template&id=21552ca6"
import script from "./EmojiContent.vue?vue&type=script&lang=js"
export * from "./EmojiContent.vue?vue&type=script&lang=js"
import style0 from "./EmojiContent.vue?vue&type=style&index=0&id=21552ca6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports